import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  output,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AsYouType, CountryCode, parsePhoneNumber } from 'libphonenumber-js';

import { digitRegex, regexpMatchLength } from '@blaze-shared/shared-util';

import { type InlineEditorConfig } from '../base-editor/inline-editor.types';

@UntilDestroy()
@Component({
  selector: 'be-phone-editor',
  templateUrl: './phone-editor.component.html',
  styleUrls: ['./phone-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TablePhoneEditorComponent implements AfterViewInit {
  valueChange = output<string>();

  @Input() config?: InlineEditorConfig;

  @ViewChild('stringInput') stringInput!: ElementRef<HTMLInputElement>;

  private valueFormControl = new UntypedFormControl('');

  phoneFormControl = new UntypedFormControl('');

  @Input() set value(val: string | number | undefined) {
    this.phoneFormControl.patchValue(val);
  }

  constructor() {
    this.phoneFormControl.valueChanges.pipe(untilDestroyed(this)).subscribe((inputValue) => {
      const country =
        (this.config?.columnSchema?.format?.culture?.split('-')[1] as CountryCode) || 'US';

      const asYouTypeFormatter =
        regexpMatchLength(digitRegex, inputValue) > 3
          ? new AsYouType(country).input(inputValue || '')
          : inputValue;
      const numberValue =
        regexpMatchLength(digitRegex, inputValue) > 3
          ? parsePhoneNumber(inputValue, country).number
          : inputValue;
      if (numberValue !== this.valueFormControl.value) {
        this.valueFormControl.patchValue(numberValue, { emitEvent: false });
        this.emitValue(numberValue);
      }
      if (asYouTypeFormatter !== this.phoneFormControl.value) {
        this.phoneFormControl.patchValue(asYouTypeFormatter, { emitEvent: false });
      }
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.stringInput.nativeElement.focus();
      this.stringInput.nativeElement.select();
    });
  }

  private emitValue(value: string): void {
    this.valueChange.emit(value);
  }
}
